import axios from "axios";

let baseURL = process.env.REACT_APP_API_URL|| "http://localhost:3002/api";
baseURL = baseURL + '1';

export default axios.create({
  baseURL,
});